export enum CustomFavicon {
  FAVICON_TCB = 'faviconTcb',
  FAVICON_BASK = 'faviconBask',
}

export type AvailableCustomFavicons = { [key in CustomFavicon]: string };

export const customFavicons: AvailableCustomFavicons = {
  faviconTcb: 'favicon.ico',
  faviconBask: 'favicon-bask.ico',
};
